import React ,{useState} from 'react'
import './business-liability-insurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const BusinessLiabilityInsurance = () => {
    const [hrefData, setHrefData] = useState();
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Business owner insurance", link: "/what-we-offer/insurance-products/business-owner-insurance" },
        { label: "Business liability insurance", link: "/what-we-offer/insurance-products/business-owner-insurance/business-liability-insurance" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "difference",
            label: "The Sentry difference",
        },
        {
            id: "Businessliability",
            href: "Businessliability",
            label: "Business liability insurance coverages",
        },
        {
            id: "help",
            href: "help",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Protect your business from uncertainties',
        blue_para: 'Business liability insurance helps protect you and your business. Depending on your line of work, you likely have risks that are specific to your industry. That’s why we’ll work with you and get to know your business so we can help determine if you need any special coverages to help protect your business.',
        purple_icon: images['Icon_of_two_purple_chairs.svg'],
        purple_heading: 'We’ll help protect your business',
        purple_para: "We offer a broad range of liability coverages, from employment practices to premises and product.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['two-people-reading-article.svg'],
            para: 'Running a business comes with uncertainties. With business liability insurance, we can help you protect your business from the unknown. In the event of an accident, liability insurance helps cover medical, legal, or damage expenses that you are found liable for. From general liability insurance to coverages specific to your business, we can help you protect what’s most important to you.',
        },
    ];
    return (
        <>
            <div className='business-liability-insurance'>
                {/* hero section */}
                <Hero img={images["Aerial_view_of_two_business_meeting_looking_at_tablet.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Business liability insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} hrefData={hrefData}
                    setHrefData={setHrefData} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card' id='difference'>
                        <h1>The Sentry difference</h1>
                        <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard id='Businessliability' Title="Business liability insurance coverages" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} id='help'/>
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default BusinessLiabilityInsurance